import React from 'react';
import { Card } from "react-bootstrap";
import face_image_1 from "../../assets/img/faceAttilaLovas.jpeg";
import face_image_2 from "../../assets/img/faceBalazsHeilig.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projLovasA_HeiligB_ionosphere.png";

const A_Lovas_and_B_Heilig_ionosphere = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div style={{width: '183px'}}> {/* This is an ugly solution, but it works for now */}
            <img
              className="img2"
              src={face_image_1}
              
            />{" "}
            <p className="text7">Attila Lovas{" "}</p>
            <br />
            <p className="text8">
              Research Fellow{" "}
            </p>
            </div>
            <div style={{width: '183px'}}>
            <img
              className="img2"
              src={face_image_2}
              
            />{" "}
            <p className="text7">Balázs Heilig{" "}</p>
            <br />
            <p className="text8">
              Deputy Director General{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Rényi Alfréd Institute of Mathematics, HUN-REN </p>
            </div>
            <div>
            <p className="text8">HUN-REN EPSS </p>
            </div>
            <div>
            Data assimilation is a mathematical and computational framework that combines predictions from physical or 
            empirical models with observational data in order to obtain more accurate and reliable estimates of the 
            system state. In the ionosphere–plasmasphere system, data assimilation plays a crucial role due to its 
            strong impact on radio-wave propagation, satellite-based navigation, and space weather phenomena.
            <br/>
            <br/>
            The coupled ionosphere–plasmasphere dynamics can be described by nonlinear, time-dependent partial 
            differential equations.
            <br/>
            <br/>
            Motivation for data assimilation:

            <ul>
                <li>
                    Highly complex dynamics with strong nonlinearities and multi-scale behavior
                </li>
                <li>
                    Sparse and irregular observations in space and time
                </li>
                <li>
                    Explicit uncertainty quantification of both model and observations
                </li>
            </ul>
            <br/>
            
            Data assimilation techniques:
            <ul>
                <li>
                    Kalman Filter (KF) or Extended Kalman Filter (EKF), for linear or weakly nonlinear systems.
                </li>
                <li>
                    Ensemble Kalman Filter (EnKF), a Monte Carlo approach representing the state distribution by an ensemble.
                </li>
                <li>
                    Particle Filter (PF), suitable for strongly nonlinear and non-Gaussian problems.
                </li>
                <li>
                    Variational methods (3D-Var, 4D-Var), formulated as an optimization problem.
                </li>
            </ul>
            <br/>

            Assimilated data sources:
            <ul>
                <li>
                    GNSS TEC observations (GPS, Galileo, GLONASS, BeiDou)
                </li>
                <li>
                    EMMA magnetometer-based field line resonance plasma density estimates
                </li>
                <li>
                    AWDANet VLF whistler dispersion-derived equatorial electron densities
                </li>
            </ul>
            <br/>
            Scientific and engineering challenges

            <ul>
                <li>
                    Coupling PDE-based physical models with discrete, noisy observations
                </li>
                <li>
                    Stability and convergence analysis of assimilation algorithms
                </li>
                <li>
                    Feasibility of near-real-time operational implementations
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default A_Lovas_and_B_Heilig_ionosphere;